<template>
  <div>
    <card-wrapper>
      <matrix-upload-form :action-text="$t('page.control.form.actionText')" :action="control" />
    </card-wrapper>

    <card-wrapper>
      <control-tabs />
    </card-wrapper>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import MatrixUploadForm from '@/components/matrix-upload-form.vue';
import ControlTabs from '@/components/control-report/control-tabs.vue';
import CardWrapper from '@/components/interface/card-wrapper.vue';
import { control, reset } from '@/modules/matrix';

export default Vue.extend({
  components: {
    MatrixUploadForm,
    ControlTabs,
    CardWrapper
  },
  methods: {
    control
  },
  destroyed: reset
});
</script>
